import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface TransferTransactionPayload {
  // TODO: Verify and update the request payload based on the final backend contract.
  buyer_id: string
  seller_id: string
  reason: string
  seller_bank_account: string
  seller_bank_account_country: string
  buyer_bank_account: string
  buyer_paypal_bank_account: string
  buyer_revolut_bank_account: string
  seller_transfer_methods: string[]
  buyer_transfer_methods: string[]
  amount: string
  exchange_rate: string
  buyer_discount: string
  seller_discount: string
}

export interface TransferTransactionResponse {
  source_transaction_id: string
  new_transaction_id: string
  transfer_id: string
}

export function transferTransactionAction(
  transactionCuid: string,
  payload: TransferTransactionPayload
): Promise<ApiResponse<TransferTransactionResponse | null>> {
  const url = `/transactions/${transactionCuid}/transfer`

  return api.v2.post<ApiResponse<TransferTransactionResponse | null>>(
    url,
    payload as unknown as Record<string, unknown>
  )
}
